import { render, staticRenderFns } from "./TripWidgets.vue?vue&type=template&id=55c2d370&scoped=true&"
import script from "./TripWidgets.vue?vue&type=script&lang=js&"
export * from "./TripWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2d370",
  null
  
)

export default component.exports